/**
 * Determines if this is an update/insert.
 */
export enum UpsertType {
    Insert = "Insert",
    Update = "Update"
}